module.exports = __webpack_public_path__ + "img/20220310_150844.e7bfe3b9.jpg";